<template>
  <div class="fill-height" style="overflow: hidden">
    <div class="stepperContext fill-height">
      <div class="headerContext d-flex justify-center pt-8">
        <div>
          <img src="../../assets/logo/Logo.svg" alt="">
        </div>
      </div>
      <div>
        <v-fade-transition mode="out-in">
          <div :key="1" class="questionSlider mt-15" v-if="!therapists">
            <div class="titleQuestion">
              شرح مسئله خود را وارد کنید.
            </div>
            <v-form ref="cc">
              <v-textarea
                  outlined
                  :rules="requiredRules"
                  v-model="cc"
                  style="margin-top: -15px;direction: rtl !important;"
                  reverse></v-textarea>
            </v-form>
            <div class="buttonSlier " @click="sendCCAndGetDoctor">
              پیشنهاد دکتر
            </div>
          </div>
          <div :key="2" v-else class="questionSlider">
            <div class="titleQuestion text-center mt-10">
              دکترهای پیشنهادی برای شما
            </div>
            <v-row>
              <v-col v-for="(therapist , i) in therapists" :key="i" md="4" cols="6" lg="4">
                <div class="therapistImage">
                  <img width="100%" :src="therapist.user.avatar" alt="">
                </div>
                <div class="doctorName text-center">
                  {{ therapist.user.full_name }}
                </div>
                <a :href="therapist.resume_link" target="_blank">
                  <div class="resumeBtn text-center mt-2">
                    <v-btn x-small color="primary" elevation="0">
                      نمایش رزومه
                    </v-btn>
                  </div>
                </a>
              </v-col>
            </v-row>
          </div>
        </v-fade-transition>
      </div>

    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";


export default {


  data() {
    return {
      cc: "من نیاز به مشاوره فردی دارم و احساس میکنم همیشه افسردگی و نگرانی زیادی دارم. دوست دارم تراپیست مرد باشه و ترجیحا بالای 40 سال ",
      therapists: null,
    }
  },

  methods: {
    sendCCAndGetDoctor() {
      if (this.$refs.cc.validate()) {
        this.requesting('match_making', 'suggestDoctor', {}, {cc: this.cc}).then((resp) => {
          this.therapists = resp.data.therapists
        })
      }
    },


    addProfileData() {


      const profileQuestions = [
        {
          id: 11,
          title: "اطلاعات هویتی",
          placeHolder: "",
          question: "نام و نام خانوادگی",
          options: null
        },
        {
          id: 12,
          title: "اطلاعات هویتی",
          placeHolder: "",
          question: "در چه کشوری زندگی میکنید ؟",
          options: null
        },
        {
          id: 13,
          title: "اطلاعات هویتی",
          placeHolder: "",
          question: "سن خود را وارد کنید.",
          options: null
        },
        // {
        //   id : 14,
        //   title : "اطلاعات هویتی",
        //   placeHolder : "",
        //   question : "جنسیت خود را انتخاب کنید.",
        //   options : [
        //     {id : 0 , label : "مرد",value : "مرد"},
        //     {id : 1 , label : "زن",value : "زن"},
        //     {id : 2 , label : "ترجیج میدم نگم.",value : "ترجیج میدم نگم."},
        //
        //   ]
        // }
      ]

      this.questions = [...this.questions, ...profileQuestions]
      this.answers = [...this.answers, ...[this.profile.firstname + "  " + this.profile.lastname, this.profile.country.name, this.isJalali ? this.jalaliToGregorian(this.profile.birthDate) : this.profile.birthDate, this.profile.gender]]

    },


    saveProfile() {


      if (this.$refs.childForm.validateForm()) {

        let data = {
          birth_date: this.isJalali ? this.jalaliToGregorian(this.profile.birthDate) : this.profile.birthDate,
          name: this.profile.firstname,
          family: this.profile.lastname,
          gender: this.profile.gender,
          "country_id": this.profile.country_id,
        };

        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'editProfile', '', data).then(() => {

        }).finally(() => {

          this.$emitEvent('setLoading', false)

          this.sendData()


        })
        this.state = "done"
      }
    },
    showNotify(text, color) {
      this.notify = true
      this.notifyText = text
      this.notifyColor = color
    },
    goToNextQuestion(i) {
      if (this.answers[i] != undefined && this.answers[i] != "") {
        if (this.questionStepper === this.questions.length) {
          this.state = "profileData"
        } else {
          this.questionStepper++; // Move to next step
        }
      } else {
        this.showNotify('به سوال پاسخ دهید', 'red')
      }
    },
    sendData() {


      let payload = []

      this.addProfileData()
      this.questions.forEach((item, i) => {
        payload.push({
          question: item.question,
          answers: this.answers[i]
        })
      })


      console.log({
        type: 'presession',
        sub_type: 'static_presession',
        version: 1,
        answers: payload,
      })

      this.$emitEvent('setLoading', true)
      this.requesting('user', 'processStaticPresession', {}, {
        type: 'presession',
        sub_type: 'static_presession',
        version: 1,
        answers: payload,
      }).then((resp) => {

        this.event = resp.data
        console.log(this.event, 'vdsvdsvds')

      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    endIntroSlider() {
      this.state = 'question'
    },
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    }),
    progress() {
      return (this.questionStepper / this.questions.length) * 100;
    }
  },
  beforeMount() {
    // Disable RTL for this page
    this.$vuetify.rtl = false;
  },
  beforeDestroy() {
    // Re-enable RTL when leaving the page
    this.$vuetify.rtl = true;
  },


}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .stepperContext {
    width: 95% !important;
  }

  .introSlide img {
    width: 80% !important;
  }

  .titleQuestion {


    height: unset !important;
    margin-bottom: 25px;

  }

}

.questionSlider {
  direction: rtl;
}

.titleQuestion {
  color: #3d5656;
  font-size: 13pt;
  height: 60px;
  font-family: bold !important;
}

.questionCounter {
  color: rgb(119 137 137/1);
}

.totalQuestionCount {
  color: rgb(61 86 86/1);
  font-family: bold !important;
}

.headerContext {
  direction: rtl !important;
  justify-content: space-between;
}

.buttonSlier {
  background: #1cba88;
  padding: 10px;
  font-family: bold !important;
  color: white;
  cursor: pointer;
  border-radius: 12px;
  margin-top: 50px;
  text-align: center;
}

.sliderContent {
  width: 90%;
  margin: 0px auto;
}

.stepperContext {
  width: 500px;
  margin: 0px auto;
}

.introSlide img {
  width: 100%;
}

.introSlide {
  text-align: center;
  direction: rtl;
}

.titleSlider {
  font-size: 15pt;
  font-family: bold !important;
  color: rgb(61 86 86/1);
  margin-bottom: 10px;
}

.contentSlider {
  font-size: 11pt;
  color: rgb(61 86 86/1);

}

</style>
